/* global ga */
/* global gtag */
export default {
  methods: {
    triggerFromInquilinosVip: triggerFromInquilinosVip,
    triggerFromOnboarding: triggerFromOnboarding,
    triggerFromSignUp: triggerFromSignUp,
    triggerFromLogin: triggerFromLogin,
    triggerFromCampaign: triggerFromCampaign,
    trigger: trigger,
  }
}

const EVENT_ACTIONS = {
  click: 'click',
  scroll: 'scroll'
};

function trigger(object){
  if (typeof ga !== 'undefined') {
    ga('send', {
      hitType: 'event',
      eventCategory: object.eventCategory,
      eventAction: object.eventAction,
      eventLabel: object.eventLabel
    });
    gtag_report_conversion(object.eventLabel);
  }
}

function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
    'send_to': 'AW-834750628/wnZ1CMT-0p8BEKSRhY4D',
    'event_callback': callback
  });
  return false;
}

function triggerFromSignUp(location){
  let params = {
    event: 'SignUpEvent',
    eventCategory: 'SignUp Button',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromInquilinosVip(location){
  let params = {
    event: 'InquilinosVipEvent',
    eventCategory: 'Inquilino VIP Button',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromOnboarding(location){
  let params = {
    event: 'OnboardingEvent',
    eventCategory: 'Registration Onboarding Button',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromLogin(location){
  let params = {
    event: 'LoginEvent',
    eventCategory: 'Sign in button',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromCampaign(location){
  let params = {
    event: 'CampaignRegistration',
    eventCategory: 'Sign up button',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params)
}